import Spinners from "components/Common/Spinner"
import SnackbarComponent from "components/SnackBar"
import React from "react"
import { useSelector } from "react-redux"
import PrimaryButton from "../../newcomponents/primary-button"
import "../../newcomponents/index.css"
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import { Height } from "@mui/icons-material"

const EditCustomerCard = ({
  validation,
  err,
  success,
  setErr,
  setSuccess,
  setEditTabVisible,
  isLoading,
}) => {
  const mode = useSelector(state => state.Layout.layoutMode)
  return (
    <Form
      className="form-horizontal"
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <div
        style={{
          borderRadius: "20px",
          padding: "10px 10px",
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          boxShadow:
            mode === "dark"
              ? "0 0 20px rgba(0,0,0,0.5)"
              : "0 0 20px rgba(0,0,0,0.1)",
        }}
      >
        <h4 className="card-title mt-2 mb-4">
          <span
            className="mdi mdi-arrow-left"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setEditTabVisible(false)
            }}
          ></span>{" "}
          Update Customer
        </h4>

        <Card
          style={{
            backgroundColor: "transparent",
            boxShadow: "transparent",
          }}
        >
          <CardBody
            style={{
              backgroundColor: "transparent",
              boxShadow: "transparent",
            }}
          >
            <Row className="mt-2">
              <Col md={4}>
                <div className="form-group">
                  <Label className="form-label">Name</Label>
                  <Input
                    name="customer.name" // Use nested naming
                    className="form-control"
                    placeholder="Enter Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.customer.name}
                    invalid={
                      validation.touched.customer?.name &&
                      !!validation.errors.customer?.name
                    }
                    autoComplete="off" // Changed to camelCase
                  />
                  <FormFeedback>
                    {validation.errors.customer?.name}
                  </FormFeedback>
                </div>
              </Col>

              <Col md={4}>
                <div className="form-group">
                  <Label className="form-label">Email</Label>
                  <Input
                    name="customer.email" // Use nested naming
                    className="form-control"
                    placeholder="Enter Email"
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.customer.email}
                    invalid={
                      validation.touched.customer?.email &&
                      !!validation.errors.customer?.email
                    }
                  />
                  <FormFeedback>
                    {validation.errors.customer?.email}
                  </FormFeedback>
                </div>
              </Col>

              <Col md={4}>
                <div className="form-group">
                  <Label className="form-label">Contact</Label>
                  <Input
                    name="customer.contact" // Use nested naming
                    className="form-control"
                    placeholder="Enter Contact"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.customer.contact}
                    invalid={
                      validation.touched.customer?.contact &&
                      !!validation.errors.customer?.contact
                    }
                  />
                  <FormFeedback>
                    {validation.errors.customer?.contact}
                  </FormFeedback>
                </div>
              </Col>
            </Row>

            {/* Multi-select organization dropdown */}

            <div className="text-center mt-4">
              <PrimaryButton
                style={{
                  width: "150px",
                  height: "40px",
                  padding: "0px 0px",
                  color: mode === "dark" ? "#fff" : "#2990DF",
                  fontSize: "14px",
                }}
                type="submit"
              >
                {isLoading ? (
                  <Spinners
                    style={{
                      color: mode === "dark" ? "#fff" : "#2990DF",
                      fontSize: "14px",
                    }}
                    size="sm"
                  />
                ) : (
                  "Update Customer"
                )}
              </PrimaryButton>
            </div>
          </CardBody>
        </Card>
      </div>
    </Form>
  )
}

export default EditCustomerCard
